import { OrderForm } from './OrderForm'

export default OrderForm
